const cache = {}

export default page => {
  if (cache[page]) {
    return Promise.resolve(cache[page])
  }
  return fetch(page)
    .then(res => res.text())
    .then(content => {
      cache[page] = content
      return content
    })
}
